import * as HTTP from "./base";

let endpoint = "user";

const getAll = async (queryString = "") => {
  return await HTTP.get(`${endpoint}${queryString}`);
};

const post = async (data) => {
  return await HTTP.post(endpoint, data);
};

const getById = async (id) => {
  return await HTTP.get(`${endpoint}/${id}`);
};

const update = async (id, data) => {
  return await HTTP.put(`${endpoint}/${id}`, data);
};

const destroy = async (id) => {
  return await HTTP.destroy(`${endpoint}/${id}`);
};

const getAllCompany = async (id) => {
  return await HTTP.get(`${endpoint}/${id}/companies`);
};
const postCompany = async (id, data) => {
  return await HTTP.post(`${endpoint}/${id}/companies`, data);
};
const getByIdCompany = async (id, idCompany) => {
  return await HTTP.get(`${endpoint}/${id}/companies/${idCompany}`);
};
const updateCompany = async (id, idCompany, data) => {
  return await HTTP.put(`${endpoint}/${id}/companies/${idCompany}`, data);
};
const destroyCompany = async (id, idCompany) => {
  return await HTTP.destroy(`${endpoint}/${id}/companies/${idCompany}`);
};

export {
  getAll,
  post,
  getById,
  update,
  destroy,
  getAllCompany,
  postCompany,
  getByIdCompany,
  updateCompany,
  destroyCompany,
};
